import { useQueryClient } from '@tanstack/react-query';

import { type PricePolicyContent } from '../api';
import { PRICE_POLICY_CONTENT_KEY } from './queryKey';

export type UsePricePolicyContentQueryResult = {
    pricePolicyData: PricePolicyContent | undefined;
};

export const usePricePolicyContentQuery = (): UsePricePolicyContentQueryResult => {
    const queryClient = useQueryClient();

    const pricePolicyData = queryClient.getQueryData<PricePolicyContent>([PRICE_POLICY_CONTENT_KEY]);

    return { pricePolicyData };
};
